export const MIN_DEVICE_LIMIT = 1;
export const MAX_DEVICE_LIMIT = 10;
